module.exports = __webpack_public_path__ + "img/07.db828e78.png";